import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PowCaptchaWidget from './components/PowCaptchaWidget';
import PowCaptchaState from './states/PowCaptchaState';

/**
 * Whether a given form type has CAPTCHA enabled (setting serialised to the
 * forum JSON:API resource by extend.php).
 */
function isEnabled(key) {
  return !!app.forum.attribute('peopleinside-powcaptcha.' + key);
}

/**
 * Extend a modal with the PoW CAPTCHA widget.
 *
 * @param modulePath  Lazy-module path of the Flarum modal component.
 * @param enabledKey  Forum-attribute key that controls whether CAPTCHA is active.
 * @param dataMethod  Name of the method that builds the POST body.
 */
function applyToModal(modalPath, enabledKey, dataMethod) {
  // Create the state object when the modal is initialised.
  extend(modalPath, 'oninit', function () {
    if (!isEnabled(enabledKey)) return;
    this.powCaptchaState = new PowCaptchaState();
  });

  // Inject the token into the request payload.
  extend(modalPath, dataMethod, function (data) {
    var _this$powCaptchaState, _this$powCaptchaState2;
    if (!isEnabled(enabledKey)) return;
    data['captchaToken'] = (_this$powCaptchaState = (_this$powCaptchaState2 = this.powCaptchaState) == null ? void 0 : _this$powCaptchaState2.getResponse()) != null ? _this$powCaptchaState : '';
  });

  // Add the widget to the form's field list (just above the submit button).
  extend(modalPath, 'fields', function (items) {
    if (!isEnabled(enabledKey)) return;
    if (!this.powCaptchaState) return;
    items.add('pow-captcha', m(PowCaptchaWidget, {
      state: this.powCaptchaState
    }), -5);
  });

  // Restart the widget when a submission error occurs.
  extend(modalPath, 'onerror', function () {
    var _this$powCaptchaState3;
    if (!isEnabled(enabledKey)) return;
    (_this$powCaptchaState3 = this.powCaptchaState) == null || _this$powCaptchaState3.retry();
  });
}

/**
 * Wire up the PoW CAPTCHA to all three auth modals.
 */
export default function extendAuthModals() {
  applyToModal('flarum/forum/components/LogInModal', 'enabledLogin', 'loginParams');
  applyToModal('flarum/forum/components/SignUpModal', 'enabledSignup', 'submitData');
  applyToModal('flarum/forum/components/ForgotPasswordModal', 'enabledForgot', 'requestParams');
}